// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2RYo5","info":"UpdateTermsInfo_info__IMsTF"};